import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { useT } from "@/context/LanguageContext";

export default function Testimonials({ items = [] }) {
  const { t, ui } = useT();
  return (
    <section className="relative bg-[color:var(--gcs-ivory)] py-24 md:py-40" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14">
          <div className="md:col-span-4">
            <p className="overline text-[color:var(--gcs-gold)] mb-4">{ui("testimonials.chapter")}</p>
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-[color:var(--gcs-gold)] text-[color:var(--gcs-gold)]" />
              ))}
              <span className="ml-2 text-sm text-[color:var(--gcs-emerald)]/70">{ui("testimonials.rating")}</span>
            </div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-[color:var(--gcs-emerald)]">
              {ui("testimonials.h1_a")}<em className="text-[color:var(--gcs-gold)]">{ui("testimonials.h1_em")}</em>{ui("testimonials.h1_b")}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((it, i) => (
            <motion.blockquote
              key={it.id || i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="relative p-8 md:p-10 bg-[color:var(--gcs-ivory-2)] border border-[color:var(--gcs-line)] rounded-sm"
              data-testid={`testimonial-${i}`}
            >
              <span className="absolute -top-5 left-8 font-serif text-6xl text-[color:var(--gcs-gold)]">“</span>
              <p className="font-serif italic text-xl md:text-2xl text-[color:var(--gcs-emerald)] leading-snug">
                {t(it.quote)}
              </p>
              <footer className="mt-6 pt-6 border-t border-[color:var(--gcs-line)] flex items-center justify-between">
                <div>
                  <div className="font-serif text-lg text-[color:var(--gcs-emerald)]">{it.author}</div>
                  <div className="overline text-[color:var(--gcs-gold)]">{it.location}</div>
                </div>
                <div className="flex items-center gap-0.5">
                  {[...Array(5)].map((_, k) => (
                    <Star key={k} className="w-3 h-3 fill-[color:var(--gcs-gold)] text-[color:var(--gcs-gold)]" />
                  ))}
                </div>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
